import type { RenderSlateElementProps } from 'types/slate';
import { getStyle } from '../utils';

/**
 * Renders a list item element for a rich text editor.
 *
 * @param {RenderSlateElementProps} props - The properties for the list item renderer.
 * @returns {JSX.Element} The rendered list item element.
 */
/**
 * NOTE: element.children[0].color is used to get the color of the first child node.
 * If the first child node is selected with custom color then it will be used.
 * Otherwise, it will use the default color defined in the element.
 */
export const renderListItem = ({
  attributes,
  element,
  children,
}: RenderSlateElementProps): JSX.Element => (
  <li
    {...attributes}
    style={{ ...getStyle(element) }}
  >
    {children}
  </li>
);
